export const useFluentChartViewOptions = () => ({ hasChartData: true }); // TODO: Implement useFluentChartViewOptions
